import type { ExperimentConfig } from '../@types'

const config: ExperimentConfig[] = [
	{
		'activity-female-tai-chi-walking-v2': {
			// ?safe&mock-data&utm_source=FB&country=US&area=activity-female-tai-chi-walking-v2&exp=web_tai_chi_fem_v2_gifs_exercise~1
			funnel: {
				id: 'ob-female-tai-chi-walking-v2-gifs',
				locale: ['en'],
			},
		},
	},
]

export default config
